/* @flow */

import React from 'react';
import PropTypes from '../util/prop_types';

export default class SearchPin extends React.PureComponent {
  static propTypes = {
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
    text: PropTypes.string,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    backgroundColor: '#035642',
    color: '#fff',
    size: 40,
    text: '',
  }

  render() {
    const { backgroundColor, color, size, text, onClick } = this.props;

    if (text) {
      return (
        <svg height={size} width={size} viewBox='0 0 48 52'
          style={{cursor: 'pointer'}}
          onClick={onClick} >
          <path
            fill={backgroundColor}
            d="M24 2c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z"
            stroke={color}
            strokeWidth="2" />
          <text x="50%" y="50%" textAnchor="middle" fill={color}>{text}</text>
        </svg>
      );
    }
    else {
      return (
        <svg height={size} width={size} viewBox='0 0 30 30'
          style={{cursor: 'pointer'}}
          onClick={onClick} >
          <path
            fill={backgroundColor}
            d="M15,27.8c-0.6-2.9-1.6-5.3-2.9-7.5c-0.9-1.6-2-3.2-3-4.8c-0.3-0.5-0.6-1.1-0.9-1.6
              c-0.6-1.1-1.2-2.4-1.1-4c0-1.6,0.5-2.9,1.2-4c1.1-1.7,3-3.2,5.5-3.6c2-0.3,4,0.2,5.3,1c1.1,0.7,2,1.5,2.6,2.5
              c0.7,1.1,1.2,2.3,1.2,4c0,0.8-0.1,1.6-0.3,2.3c-0.2,0.7-0.5,1.2-0.8,1.8c-0.6,1.1-1.2,2.2-1.9,3.2C17.8,20.2,15.9,23.4,15,27.8z"
            stroke={color}
            strokeWidth="1" />
          <circle id="svg_4" cx="15.1" cy="9.4" r="2.8" fill={color} />
        </svg>
      );
    }
  }
}
